<template>
    <v-container style="padding-top: 80px">
        <v-card>
            <v-card-title class=" primary">
                <span class="card-title-text" style="color: white;">Autorizar Vacaciones</span>
            </v-card-title>
            <v-card-text>
                <v-row justify="center">
                    <v-col cols="12">
                        <v-row justify="center">
                            <v-col cols="12" md="6" style="display: flex; justify-content: space-around;">
                                <v-toolbar-title v-if="$refs.calendar" class="tituloMes"> {{ $refs.calendar.title }}
                                </v-toolbar-title>
                                <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">HOY</v-btn>
                                <v-btn fab text small color="grey darken-2" @click="prev">
                                    <v-icon small> mdi-chevron-left </v-icon>
                                </v-btn>
                                <v-btn fab text small color="grey darken-2" @click="next">
                                    <v-icon small> mdi-chevron-right </v-icon>
                                </v-btn>
                            </v-col>
                            <v-col cols="12" md="6" v-if="mostrar"
                                style="justify-content: space-around; display: flex;">
                                <v-toolbar-title v-if="$refs.calendarMesmas" class="tituloMes">
                                    {{ $refs.calendarMesmas.title }}
                                </v-toolbar-title>
                                <v-tooltip bottom v-if="this.showTodo == 0">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn fab dark small color="success" @click="showTodo = 1; ObtenerUsuario()"
                                            v-bind="attrs" v-on="on">
                                            <v-icon>
                                                mdi-eye
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Contemplar más usuarios</span>
                                </v-tooltip>
                                <v-tooltip bottom v-else>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn fab dark small color="error" @click="showTodo = 0; ObtenerUsuario()"
                                            v-bind="attrs" v-on="on">
                                            <v-icon>
                                                mdi-eye-off
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Contemplar menos usuarios</span>
                                </v-tooltip>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-row justify="center">
                        <v-col cols="12" md="6">
                            <v-row justify="center" style="margin: 2vh;">
                                <v-calendar ref="calendar" v-model="focus" color="primary" :type="type"
                                    :event-color="getEventColor" :events="otrosusers" locale="es" @click:more="showMore"
                                    event-more-text="{0} usuario(s) más" style="height: 500px; width: 100%;"
                                    @click:event="showEvent" :show-adjacent-months="true"></v-calendar>
                            </v-row>
                        </v-col>
                        <v-col cols="12" md="6" v-if="!mostrar">
                            <v-row>
                                <v-col cols="6" md="6">
                                    <v-toolbar-title v-if="$refs.calendarMesmas" style="padding-left: 2vh;">
                                        {{ $refs.calendarMesmas.title }}
                                    </v-toolbar-title>
                                </v-col>
                                <v-col cols="6" md="6" style="display: flex; justify-content: space-around;">
                                    <v-tooltip bottom v-if="this.showTodo == 0">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn fab dark small color="success"
                                                @click="showTodo = 1; ObtenerUsuario()" v-bind="attrs" v-on="on">
                                                <v-icon>
                                                    mdi-eye
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Contemplar más usuarios</span>
                                    </v-tooltip>
                                    <v-tooltip bottom v-else>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn fab dark small color="error" @click="showTodo = 0; ObtenerUsuario()"
                                                v-bind="attrs" v-on="on">
                                                <v-icon>
                                                    mdi-eye-off
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Contemplar menos usuarios</span>
                                    </v-tooltip>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-row justify="center" style="margin: 2vh;">
                                <v-calendar ref="calendarMesmas" v-model="focusMesmas" color="primary" :type="type"
                                    :event-color="getEventColor" :events="otrosusers" locale="es" @click:more="showMore"
                                    event-more-text="{0} usuario(s) más" style="height: 500px; width: 100%;"
                                    @click:event="showEvent"></v-calendar>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-row>
            </v-card-text>
            <v-dialog v-model="dialog" width="auto" persistent>
                <v-card flat>
                    <v-toolbar color="primary" dark>
                        <v-toolbar-title>{{ this.dia }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon dark @click="dialog = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <div class="miniCalendario">
                            <v-list-item v-for="(usuario) in usuariosVac" :key="usuario.vcid">
                                <div class="usuario" :style="{ background: usuario.color }">
                                    <div class="pl-1">
                                        <span>{{ usuario.nombre }}</span>
                                    </div>
                                </div>
                            </v-list-item>
                        </div>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-card>
        <v-card class="mt-2 " elevation="5" v-if="showDetalle == false">
            <v-card-text>
                <v-row justify="center">
                    <v-col cols="12" md="11">
                        <v-row justify="center" class="mt-2">
                            <v-col cols="12" md="11"
                                style="display: grid; place-items: center; font-size: large; font-weight: bold;">
                                <span>Historial de solicitudes</span>
                            </v-col>
                            <v-col cols="12" md="2" v-if="showAll == false" style="display: grid; place-items: center;">
                                <v-btn color="success" @click="MostrarTodo(0)">Mostrar Todo</v-btn>
                            </v-col>
                            <v-col cols="12" md="2" v-else style="display: grid; place-items: center;">
                                <v-btn color="secondary" @click="MostrarTodo(1)">Regresar</v-btn>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-divider></v-divider>
                            </v-col>
                        </v-row>
                        <v-row justify="center" class="mt-2">
                            <v-col>
                                <DataTable :url="urlListado" :columns="columns" :formatterActions="formatterActions"
                                    :order="[]" @apiDT="apiDT = $event" :params="displayInputs">
                                </DataTable>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-card class="mt-2" v-else>
            <v-card-title class=" primary">
                <span class="card-title-text" style="color: white;">Detalle Solicitud</span>
            </v-card-title>
            <v-card-text>
                <v-row justify="center">
                    <v-col cols="12" md="11">
                        <v-row>
                            <v-col>
                                <span class="mt-2"
                                    style="font-size: large; font-weight: bold; display: grid; place-items: center;">
                                    Nombre: {{ nombre }}
                                </span>
                            </v-col>
                        </v-row>
                        <v-row class="mt-2" justify="center">
                            <v-col cols="12" md="9">
                                <div class="card-containerVac">
                                    <v-card class="card-itemVac">
                                        <v-card-text class="card-contentVac">
                                            <div><span style="font-weight: bold;">Días restantes para solicitar
                                                    vacaciones:</span></div>
                                            <div class="mt-4">
                                                <span style="font-size: xx-large; font-weight: bold;">{{ diasplazo
                                                    }}</span>
                                            </div>
                                        </v-card-text>
                                    </v-card>
                                    <v-card class="card-itemVac">
                                        <v-card-text class="card-contentVac">
                                            <div><span style="font-weight: bold;">Días Disponibles:</span></div>
                                            <div class="mt-4">
                                                <span style="font-size: xx-large; font-weight: bold;">{{ vacdisponibles
                                                    }}</span>
                                            </div>
                                        </v-card-text>
                                    </v-card>
                                    <v-card class="card-itemVac">
                                        <v-card-text class="card-contentVac">
                                            <div><span style="font-weight: bold;">Días por autorizar:</span></div>
                                            <div class="mt-4">
                                                <span style="font-size: xx-large; font-weight: bold;">{{ vacporaut
                                                    }}</span>
                                            </div>
                                        </v-card-text>
                                    </v-card>
                                </div>
                            </v-col>
                        </v-row>
                        <v-divider class="mt-4"></v-divider>
                        <v-row class="mt-4">
                            <v-col>
                                <DataTable :url="urlDetalle" :columns="columnsDetalle" :order="[]"
                                    :params="displayInputsDetalle" @apiDT="apiDT = $event"
                                    :formatterActions="formatterActionsDetalle" @cargando="valCargando"
                                    class="vacacionesClass">
                                </DataTable>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions style="justify-content: center; align-content:end; padding: 20px;">
                <v-row justify="center">
                    <v-btn class="ma-2" color="error" title="Limpiar" @click="regresar()">
                        Regresar
                    </v-btn>
                    <v-btn class="ma-2" color="primary" title="Limpiar" @click="guardarRespuestas()"
                        v-if="showCalificar && permisoAutorizar" :disabled="disabledSave">
                        Enviar
                    </v-btn>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
import DataTable from "@/components/pages/DataTableNet/DataTable";
import Vacaciones from "@/services/Vacaciones/Vacaciones.service.js";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import { mapState, mapGetters } from "vuex";

export default {
    title() {
        return this.$route.meta.title
    },
    components: {
        DataTable,
    },
    data() {
        return {
            showAll: false,
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            landscape: true,
            urlListado: 'Vacaciones/MostrarHistorialSolJefe',
            columns: [
                { name: 'vaeid', data: 'vaeid', title: 'No. Solicitud' },
                { name: 'usnom', data: 'usnom', title: 'Nombre Solicita' },
                { name: 'vaeestatus', data: 'vaeestatus', title: 'Estatus' },
                { name: 'vaeusuario', data: 'vaeusuario', title: 'Usuario Solicita' },
                { name: 'vaefecalta', data: 'vaefecalta', title: 'Fecha Solicitud' },
                { name: 'vaefecresponde', data: 'vaefecresponde', title: 'Fecha Respuesta' },
                { name: "", data: "vaeid", title: "Opciones", formatter: [this, "DetalleSolicitud"], orderable: false },
            ],
            formatterActions: [
                { click: [this, "DetalleSol"] },
            ],
            apiDT: null,
            displayInputs: {
                tipo: 1,
                uslogin: '',
                showTodo: 0
            },
            urlDetalle: 'Vacaciones/MostrarDiasDetalleSol',
            columnsDetalle: [
                { name: 'vaddia', data: 'vaddia', title: 'Fecha Solicitada' },
                { name: 'diaSem', data: 'diaSem', title: 'Día Semana' },
                { name: 'vacperiodo', data: 'vacperiodo', title: 'Periodo' },
                { name: 'vaeresponde', data: 'vaeresponde', title: 'Autoriza' },
                { name: 'fhresp', data: 'fhresp', title: 'Fecha respuesta' },
                { name: 'vaeestatusA', data: 'vaeestatus', title: 'Autorizar', formatter: [this, "EstatusAutorizar"], orderable: false },
                { name: 'vaeestatusP', data: 'vaeestatus', title: 'Pendiente', formatter: [this, "EstatusPendiente"], orderable: false },
                { name: 'vaeestatusD', data: 'vaeestatus', title: 'Denegar', formatter: [this, "EstatusCancelar"], orderable: false },

            ],
            displayInputsDetalle: {
                vaeid: 0,
            },
            showDetalle: false,
            respuestas: {},
            formatterActionsDetalle: [
                { click: [this, "actualizarRespuesta"] },
            ],
            showCalificar: false,
            nombre: '',
            vaeid: null,
            disabledSave: false,
            otrosusers: [],
            days: [],
            focus: '',
            focusMesmas: '',
            type: 'month',
            permisoAutorizar: false,
            uslogin: '',
            usloginDesc: '',
            dia: null,
            dialog: false,
            usuariosVac: [],
            mostrar: null,
            respAnt: [],
            coloresFijos: ['#536DFE', '#FF5C93', '#FFC260', '#3CD4A0', '#9013FE', '#D17B88', '#90E0F3', '#B8B3E9', '#F4A460', '#20B2AA'],
            usloginSolicitante: '',
            showTodo: 0,
            //nuevo
            diasplazo: 0,
            vacdisponibles: 0,
            vacporaut: 0,
            showDias: false,
            periodo: ''
        }
    },
    methods: {
        reloadTable() {
            if (this.apiDT != null) {
                this.apiDT.ajax.reload(null, false);
                this.apiDT.columns.adjust().responsive.recalc();
            }
        },
        DetalleSolicitud(datos) {
            return datos.vaeid ? `<div><button type="button" class="mx-2 v-btn v-btn--is-elevated v-btn--has-bg  theme--dark v-size--small primary dt-formatterAction" aria-haspopup="true" data-action="0" data-params="${datos.vaeid}" title="Ver detalle" aria-expanded="false"><span class="v-btn__content">Detalles</span></button></div>` : ``;
        },
        EstatusAutorizar(datos) {
            if (datos.fhresp != '') {
                return (datos.vaeestatus == 'Autorizado') ? `<div style="display: grid; place-items: center; "><input type="radio" id="radio-autorizar" name="estatusRadio${datos.vadid}" value="Autorizar" readonly checked></div>` :
                    `<div style="display: grid; place-items: center; "><input type="radio" id="radio-autorizar" name="estatusRadio${datos.vadid}" value="Autorizar" disabled checked></div>`;
            } else {
                return (datos.vaeresponde == this.usloginDesc || datos.vaeresponde2 == this.usloginDesc) ? `<div style="display: grid; place-items: center; "><input type="radio" id="radio-autorizar" name="estatusRadio${datos.vadid}" value="Autorizar"></div>` :
                    `<div style="display: grid; place-items: center; "><input type="radio" id="radio-autorizar" name="estatusRadio${datos.vadid}" value="Autorizar" disabled></div>`;
            }
        },
        EstatusPendiente(datos) {
            if (datos.fhresp != '') {
                return datos.vaeestatus == 'Autorizado' || datos.vaeestatus == 'Rechazado' || datos.vaeestatus == 'Cancelado' ? `<div style="display: grid; place-items: center; "><input type="radio" id="radio-pendiente" name="estatusRadio${datos.vadid}" value="Pendiente" disabled ></div>` : ``;
            } else {
                const checked = datos.vaeestatus === 'Pendiente' ? 'checked' : '';
                return (datos.vaeresponde == this.usloginDesc || datos.vaeresponde2 == this.usloginDesc) ? `<div style="display: grid; place-items: center; "><input type="radio" id="radio-pendiente" name="estatusRadio${datos.vadid}" value="Pendiente" ${checked}></div>` :
                    `<div style="display: grid; place-items: center; "><input type="radio" id="radio-pendiente" name="estatusRadio${datos.vadid}" value="Pendiente" disabled ></div>`;
            }
        },
        EstatusCancelar(datos) {
            if (datos.fhresp != '') {
                return datos.vaeestatus == 'Rechazado' || datos.vaeestatus == 'Cancelado' ? `<div style="display: grid; place-items: center; "><input type="radio" id="radio-cancelar" name="estatusRadio${datos.vadid}" value="Cancelar" readonly checked></div>` :
                    `<div style="display: grid; place-items: center; "><input type="radio" id="radio-cancelar" name="estatusRadio${datos.vadid}" value="Cancelar" disabled></div>`;
            } else {
                return (datos.vaeresponde == this.usloginDesc || datos.vaeresponde2 == this.usloginDesc) ? `<div style="display: grid; place-items: center; "><input type="radio" id="radio-cancelar" name="estatusRadio${datos.vadid}" value="Cancelar" ></div>` :
                    `<div style="display: grid; place-items: center; "><input type="radio" id="radio-cancelar" name="estatusRadio${datos.vadid}" value="Cancelar" disabled ></div>`;
            }
        },
        MostrarTodo(tipo) {
            this.reloadTable();
            this.showAll = tipo == 1 ? false : true;
            this.displayInputs = {
                tipo: tipo,
                uslogin: this.uslogin,
                showTodo: this.showTodo
            };
            this.reloadTable();
        },
        async DetalleSol(params, datos, fila) {
            this.showDias = false;
            this.usloginSolicitante = datos.vaeusuario;
            this.showDetalle = true;
            this.displayInputsDetalle = {
                vaeid: datos.vaeid,
            };
            this.showCalificar = datos.vaeestatus === 'Pendiente' && (datos.vaeresponde === this.usloginDesc || datos.vaeresponde2 === this.usloginDesc);
            this.nombre = datos.usnom;
            this.vaeid = datos.vaeid;
            this.reloadTable();
            this.diasplazo = 0;
            /*Nuevo */
            let dias = await Vacaciones.ObtenerDiasVacaciones(datos.uslogin);
            this.periodo = datos.vacperiodo;
            this.showDias = dias.vacperiodo == datos.vacperiodo ? true : false;
            if (this.showDias) {
                this.vacdisponibles = dias.vacdisponibles;
                this.vacporaut = dias.vacporaut
                let response = await Vacaciones.ObtenerFechas(datos.uslogin);
                this.diasplazo = response.diasplazo;
            }
        },
        regresar() {
            this.showDetalle = false;
        },
        async guardarRespuestas() {
            this.disabledSave = true;
            this.$swal({
                title: 'Respondiendo solicitud, espere, por favor.',
                allowEscapeKey: false,
                allowOutsideClick: false,
                didOpen: async () => {
                    this.$swal.showLoading();
                    const respuestas = this.recogerRespuestas();
                    const values = Object.values(respuestas);
                    if (values.every((elemento, index) => elemento === this.respAnt[index])) {
                        this.$swal({
                            position: 'center',
                            icon: 'info',
                            title: 'Información',
                            text: 'No hay ningún cambio en la solicitud, favor de verificar sus respuestas.',
                            showConfirmButton: true,
                            confirmButtonColor: '#536DFE',
                            confirmButtonText: 'Aceptar',
                            allowOutsideClick: false,
                            timer: 2500,
                        }).then(async () => {
                            this.disabledSave = false;
                        })
                    } else {
                        let mostrarBoton = values.includes("Pendiente") ? true : false;
                        const respuestasFiltradas = Object.entries(respuestas).filter(([id, respuesta]) => respuesta !== "Pendiente");
                        const respuestasValidas = respuestasFiltradas.map(([, respuesta]) => {
                            if (respuesta === "Autorizar") return 'A';
                            if (respuesta === "Cancelar") return 'R';
                            if (respuesta === "Pendiente") return 'P';
                            return respuesta;
                        });
                        const ids = respuestasFiltradas.map(([id]) => parseInt(id));
                        let response = await Vacaciones.ResponderSolicitud(this.vaeid, ids, respuestasValidas, this.usloginSolicitante);
                        if (response != true) {
                            this.$swal({
                                position: 'center',
                                icon: 'warning',
                                title: 'Error',
                                text: response,
                                showConfirmButton: false,
                                timer: 3500,
                                confirmButtonText: 'Aceptar',
                                allowOutsideClick: false,
                            }).then(async () => {
                                this.disabledSave = false;
                            })
                        } else {
                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                title: 'Éxito',
                                text: 'Solicitud respondida correctamente.',
                                showConfirmButton: true,
                                confirmButtonColor: '#536DFE',
                                confirmButtonText: 'Aceptar',
                                allowOutsideClick: false,
                                timer: 2500,
                            }).then(async () => {
                                this.reloadTable();
                                await this.valCargando();
                                await this.ObtenerUsuario();
                                this.disabledSave = false;
                                this.showCalificar = mostrarBoton;
                                /*Nuevo */
                                let dias = await Vacaciones.ObtenerDiasVacaciones(this.usloginSolicitante);
                                this.showDias = dias.vacperiodo == this.periodo ? true : false;
                                if (this.showDias) {
                                    this.vacdisponibles = dias.vacdisponibles;
                                    this.vacporaut = dias.vacporaut
                                    let response = await Vacaciones.ObtenerFechas(this.usloginSolicitante);
                                    this.diasplazo = response.diasplazo;
                                }
                            });
                        }
                    }
                }
            })
        },
        recogerRespuestas() {
            // Recoger las respuestas de todos los botones de radio
            const respuestas = {};
            const radios = this.$el.querySelectorAll('input[type="radio"][name^="estatusRadio"]');
            radios.forEach(radio => {
                if (radio.checked) {
                    const id = radio.name.replace('estatusRadio', '');
                    respuestas[id] = radio.value;
                }
            });
            return respuestas;
        },
        async ObtenerUsuario() {
            let response = await Vacaciones.ObtenerDiasDeOtrosUsuarios(this.showTodo);
            this.otrosusers = response.length > 0 ? response : [];
            this.asignarColoresAusuarios();
            this.eventosIniciales = this.otrosusers.slice(); // Guardar los eventos iniciales
            this.otrosusers = this.otrosusers.map(date => ({
                name: date.nombre,
                start: new Date(date.date),
                color: date.color,
                timed: false,
            }));
            this.displayInputs = {
                tipo: this.showAll == false ? 1 : 0,
                uslogin: this.uslogin,
                showTodo: this.showTodo
            };
            this.reloadTable();
        },
        getRandomColor() {
            const letters = "0123456789ABCDEF";
            let color = "#";
            for (let i = 0; i < 6; i++) {
                color += letters[Math.floor(Math.random() * 16)];
            }
            return color;
        },
        asignarColoresAusuarios() {
            let coloresAsignados = {};
            this.otrosusers.forEach(user => {
                if (!coloresAsignados.hasOwnProperty(user.nombre)) {
                    let cantidad = Object.keys(coloresAsignados).length;
                    if (cantidad <= 10) {
                        coloresAsignados[user.nombre] = this.coloresFijos[cantidad];
                    } else {
                        coloresAsignados[user.nombre] = this.getRandomColor();
                    }
                }
                user.color = coloresAsignados[user.nombre];
            });
        },
        setToday() {
            this.focus = ''
            let fecha = new Date();
            fecha.setMonth(fecha.getMonth() + 1);
            this.focusMesmas = fecha
        },
        prev() {
            this.changeMonth(-2);
        },
        next() {
            this.changeMonth(2);
        },
        changeMonth(delta) {
            this.focusMesmas = this.calculateNewMonth(this.focusMesmas, delta);
            this.focus = this.calculateNewMonth(this.focusMesmas, -1);
        },
        calculateNewMonth(date, delta) {
            const newDate = new Date(date);
            newDate.setMonth(newDate.getMonth() + delta);
            return newDate.toISOString().split('T')[0];
        },
        getEventColor(event) {
            return event.color
        },
        showMore({ date }) {
            this.dia = date;
            const formattedDate = new Date(date).toISOString().split('T')[0]; // Convertir la fecha a ISO y obtener solo la parte de la fecha (YYYY-MM-DD)
            const events = this.eventosIniciales.filter(event => {
                const eventDate = new Date(event.date).toISOString().split('T')[0]; // Convertir la fecha del evento a ISO y obtener solo la parte de la fecha (YYYY-MM-DD)
                if (eventDate === formattedDate) {
                    return true;
                }
                return false;
            });
            this.usuariosVac = events;
            this.dia = this.usuariosVac[0].fecha;
            this.dialog = true;
        },
        showEvent({ event }) {
            let fechaFormateada = event.start.getFullYear() + '-' + ('0' + (event.start.getMonth() + 1)).slice(-2) + '-' + ('0' + event.start.getDate()).slice(-2);
            this.dia = fechaFormateada;
            const events = this.eventosIniciales.filter(event => {
                const eventDate = new Date(event.date).toISOString().split('T')[0]; // Convertir la fecha del evento a ISO y obtener solo la parte de la fecha (YYYY-MM-DD)
                if (eventDate === fechaFormateada) {
                    return true;
                }
                return false;
            });
            this.usuariosVac = events;
            this.dia = this.usuariosVac[0].fecha;
            this.dialog = true;
        },
        checkWindowSize() {
            this.mostrar = window.innerWidth >= 960 ? true : false;
        },
        async valCargando() {
            this.respAnt = [];
            const respuestas = this.recogerRespuestas();
            const values = Object.values(respuestas);
            this.respAnt = values;
        }
    },
    async mounted() {
        this.checkWindowSize();
        window.addEventListener('resize', this.checkWindowSize);
        this.$refs.calendar.checkChange()
        this.$refs.calendarMesmas.next()
        this.setToday()
        this.showTodo = 0;
        await this.ObtenerUsuario();
        this.uslogin = await MetodosGenerales.ObtenerUserName();
        this.usloginDesc = this.getUser.get(this.permission.global).uslogin;
        this.displayInputs = {
            tipo: 1,
            uslogin: this.uslogin,
            showTodo: this.showTodo
        };
        this.reloadTable();

    },
    async beforeMount() {
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '319').then(response => {
            if (response.data.length > 0) {
                response.data.forEach(permiso => {
                    if (permiso.peclave == 319)//Permiso para ver concluidos
                        this.permisoAutorizar = true;
                });
            } else {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
            }
        });
    },
    computed: {
        ...mapState(["domain", "informationPage", "permission"]),
        ...mapGetters(['getUser']),
    },
}
</script>

<style>
#radio-autorizar {
    accent-color: #3CD4A0;
    transform: scale(2);
}

#radio-pendiente {
    accent-color: rgb(0, 166, 255);
    transform: scale(2);
}

#radio-cancelar {
    accent-color: #FF5C93;
    transform: scale(2);
}

.theme--light .dia {
    color: black;
}

.theme--dark .dia {
    color: white;
}

.tituloMes {
    display: initial;
}

.vacacionesClass input[type="radio"]:disabled {
    -webkit-appearance: none;
    display: inline-block;
    width: 12px;
    height: 12px;
    padding: 0px;
    background-clip: content-box;
    border: 2px solid #d5d5d5;
    background-color: #8e8e8e;
    border-radius: 50%;
}

.usuario {
    width: auto;
    padding: 4px 10px;
    border-radius: 10px;
    color: white;
    box-sizing: border-box;
}

.miniCalendario {
    display: grid;
    place-content: center;
}

.card-containerVac {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 16px;
}

.card-itemVac {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
}

.card-contentVac {
    text-align: center;
    flex: 1;
}
</style>